<template>
  <nuxt-link
    to="/preisvorteile-sichern"
    aria-label="Zum Treueshop"
  >
    <SvgIcon
      :image="treueShopIcon"
      no-icon-class
    />
  </nuxt-link>
</template>
<script setup lang="ts">
import treueShopIcon from '~/assets/images/rabatt-aktion-logo.svg';
</script>
